import { Form, Input, Row, Col, Switch, Select, DatePicker, InputNumber } from 'antd';
import { useEffect, useRef, useState, } from 'react';
import AntDraggableModal from '../../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../../system/WebEditUniversalNewEx';
import getList from '../../../../utilsTsx/universal/getList';
import fetchApi from '../../../../utils/api/fetchApi';
import dayjs from 'dayjs';

//布局
const layout = {
    // labelCol: { span: 8 },
    // wrapperCol: { span: 16 }, 
};

const WebEdit = (props: any) => {
    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);
    const [customerServiceOperator, setCustomerServiceOperator] = useState<any>();
    /** 后端数据defaultService */
    let defaultService: any = '';

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            defaultService = ref.current.defaultService;
        }
        const fetchData = async () => {
            fetchApi.GET(defaultService, {
                apiId: "customerServiceOperator",
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setCustomerServiceOperator(res.data);
                }
            })
        };
        fetchData();
    }, []);

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'customerService',
        serviceId: 'business',
        dateColumnName: ['accessDate', 'leaveDate', 'validityPeriod']
    };

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '客户服务'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={700}>

                <Form
                    {...layout}
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                // onKeyPress={(e: any) => {
                //     if (e.key === 'Enter') {
                //         handleOk(e)
                //     }
                // }}
                >
                    <Row gutter={[8, 0]}>
                        <Col span={24}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="wxOpenId"
                                name="wxOpenId"
                                rules={[{ required: true, message: '微信openId!' }]}>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="使用"
                                name="customerServiceOperatorId"
                                rules={[{ required: true, message: '客服使用者!' }]}>
                                <Select
                                    showSearch
                                    placeholder="客服使用者"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(customerServiceOperator, { itemName: 'operatorName' })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={11}>
                            <Form.Item
                                label="接入时间"
                                name="accessDate"
                                initialValue={dayjs(new Date())}>
                                <DatePicker
                                    format="YYYY-MM-DD HH:mm:ss"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={13}>
                            <Form.Item
                                label="当前接入id"
                                name="currentAccessId">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={11}>
                            <Form.Item
                                label="离开时间"
                                name="leaveDate"
                                initialValue={dayjs(new Date())}>
                                <DatePicker
                                    format="YYYY-MM-DD HH:mm:ss"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="下发有效期"
                                name="validityPeriod"
                                initialValue={dayjs(new Date())}>
                                <DatePicker
                                    format="YYYY-MM-DD HH:mm:ss"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="下发条数"
                                name="allowedMessageQuota">
                                <InputNumber />
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item
                                label="接入"
                                name="isAccess"
                                valuePropName="checked"
                                initialValue={false}>
                                < Switch checked={true}
                                    checkedChildren="是"
                                    unCheckedChildren="否" />
                            </Form.Item>
                        </Col>

                        <Col span={5}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}

export default WebEdit;